import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./styles/globals.css";
import { Toaster } from "react-hot-toast";
import { WagmiConfig, configureChains, createConfig } from "wagmi";
import { publicProvider } from "wagmi/providers/public";
import { bsc, base, polygon } from "wagmi/chains";
import { TradeContextProvider } from "./components/accountContext";
import type { DefaultToastOptions } from "react-hot-toast";
import { Provider } from "react-redux";
import { store } from "./app/store";
// import { defaultWagmiConfig } from '@web3modal/wagmi';
// import { localchain } from "./components/data";
import { createWeb3Modal, defaultWagmiConfig } from "@web3modal/wagmi/react";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const { chains, publicClient } = configureChains(
  [bsc, base, polygon],
  [publicProvider()]
);

// const config = createConfig({
//   autoConnect: false,
//   publicClient,
//   webSocketPublicClient,
//   connectors: [
//     new MetaMaskConnector({ chains }),
//     new WalletConnectConnector({
//       chains,
//       options: {
//         projectId: process.env.REACT_APP_WALLETCONNECT_PROJECT_ID as string,
//         showQrModal: true,
//       },
//     })
//   ],
// })

const metadata = {
  name: "FACE · JIC",
  description: "Scan a face. Send LOVE.",
  url: "https://face.jic.io",
  icons: ["https://face.jic.io/icon.png"],
};
// Keep non-trading profile routes renderable in local/preview environments.
// Production still receives the real WalletConnect project id from Vercel.
const projectId = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID as string;
const wagmiConfig = projectId
  ? defaultWagmiConfig({ chains, projectId, metadata })
  : createConfig({ autoConnect: false, publicClient });
if (projectId) createWeb3Modal({ wagmiConfig, projectId, chains });
const toastOptions: DefaultToastOptions = {
  style: {
    color: "white",
    borderRadius: "4px",
    backgroundColor: "gray",
  },
  success: { duration: 2000 },
};
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <WagmiConfig config={wagmiConfig}>
      <TradeContextProvider>
        <App />
        <Toaster
          position="bottom-center"
          toastOptions={toastOptions}
          containerClassName="mb-12 xs:mb-0"
        />
      </TradeContextProvider>
    </WagmiConfig>
  </Provider>

  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
